import axios from 'axios'

const API_URL = process.env.VUE_APP_API_BASE_URL + 'ai-agnet'

class AIAgentService {
  getAll () {
    return axios.get(API_URL + '/all')
  }

  getbyId (id) {
    return axios.get(API_URL + '/' + id)
  }

  ingestData (id, data, onUploadProgress = null) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    if (onUploadProgress) {
      config.onUploadProgress = onUploadProgress
    }
    return axios.post(API_URL + '/ingest-data/' + id, data, config)
  }

  create (agentData) {
    return axios.post(API_URL + '/create', agentData)
  }
}

export default new AIAgentService()
